<template lang="html">
  <div class="login-screen">
    <div class="consent-result">
      <svg v-if="success" class="consent-result__icon" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="30" fill="none" stroke="#4caf50" stroke-width="4"/>
        <path d="M19 33 L28 42 L45 24" fill="none" stroke="#4caf50" stroke-width="5"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else class="consent-result__icon" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="30" fill="none" stroke="#e25950" stroke-width="4"/>
        <path d="M22 22 L42 42 M42 22 L22 42" fill="none" stroke="#e25950" stroke-width="5"
              stroke-linecap="round"/>
      </svg>
      <h2 class="consent-result__title">
        {{ success ? $t('sso_consent.success_title') : $t('sso_consent.failed_title') }}
      </h2>
      <p class="consent-result__text">
        {{ success ? $t('sso_consent.success_text') : $t('sso_consent.failed_text') }}
      </p>
      <router-link class="consent-result__link btn btn--main" :to="{ name: 'login' }">
        {{ $t('sso_consent.go_to_login') }}
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sso-consent-result',
    computed: {
      success() {
        return this.$route.query.status === 'completed';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .consent-result {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 400px;
    max-width: 460px;
    margin: 0 auto;
    padding: 40px;
    text-align: center;

    &__icon {
      width: 72px;
      height: 72px;
      margin-bottom: 24px;
    }

    &__title {
      margin-bottom: 16px;
    }

    &__text {
      margin-bottom: 32px;
      line-height: 1.5;
    }

    &__link {
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/SsoConsentResult.vue